import { jsxs, jsx } from 'react/jsx-runtime';
import 'react';

const SmallLink = ({ testId, className })=>{
    return /*#__PURE__*/ jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: [
            /*#__PURE__*/ jsxs("g", {
                clipPath: "url(#clip0_5098_1948)",
                children: [
                    /*#__PURE__*/ jsx("path", {
                        d: "M5.0564 3.06274L5.90597 2.21317C7.52353 0.595611 10.1695 0.595611 11.787 2.21317C13.4046 3.83072 13.4046 6.47665 11.787 8.09421L10.9374 8.94378",
                        stroke: "currentColor",
                        strokeWidth: "1.4",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M8.94378 10.9373L8.09421 11.7868C6.47665 13.4044 3.83072 13.4044 2.21317 11.7868C0.595611 10.1693 0.595611 7.52335 2.21317 5.90579L3.06274 5.05621",
                        stroke: "currentColor",
                        strokeWidth: "1.4",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M9.09389 4.90613L4.90601 9.09401",
                        stroke: "currentColor",
                        strokeWidth: "1.4",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ jsx("defs", {
                children: /*#__PURE__*/ jsx("clipPath", {
                    id: "clip0_5098_1948",
                    children: /*#__PURE__*/ jsx("rect", {
                        width: "14",
                        height: "14",
                        fill: "white"
                    })
                })
            })
        ]
    });
};

export { SmallLink as default };
